import { toastr } from 'react-redux-toastr';
import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';
import { updateAvailablePaymentTypes } from 'actions/forms/saveImyTreeViewOptions';

export const UPDATE_WHD_STMT_REQUEST = 'UPDATE_WHD_STMT_REQUEST';
export const UPDATE_WHD_STMT_SUCCESS = 'UPDATE_WHD_STMT_SUCCESS';
export const UPDATE_WHD_STMT_FAILURE = 'UPDATE_WHD_STMT_FAILURE';
export const UPDATE_WHD_STMT_ROW_REQUEST = 'UPDATE_WHD_STMT_ROW_REQUEST';
export const UPDATE_WHD_STMT_ROW_SUCCESS = 'UPDATE_WHD_STMT_ROW_SUCCESS';
export const UPDATE_WHD_STMT_ROW_FAILURE = 'UPDATE_WHD_STMT_ROW_FAILURE';

function requestUpdateWhdStatement() {
  return {
    type: UPDATE_WHD_STMT_REQUEST,
  };
}

function receiveUpdateWhdStatement(statement, structure, validationResult, topAccount) {
  return {
    type: UPDATE_WHD_STMT_SUCCESS,
    statement,
    structure,
    validationResult,
    topAccount
  };
}

function rejectUpdateWhdStatement(accountId) {
  return {
    type: UPDATE_WHD_STMT_FAILURE,
    accountId
  };
}

function requestUpdateWhdStatementRow() {
  return {
    type: UPDATE_WHD_STMT_ROW_REQUEST,
  };
}

function receiveUpdateWhdStatementRow(statement, structure, isStructureValid, validationResult, topAccount) {
  return {
    type: UPDATE_WHD_STMT_ROW_SUCCESS,
    isStructureValid,
    statement,
    structure,
    validationResult,
    topAccount
  };
}

function rejectUpdateWhdStatementRow(accountId) {
  return {
    type: UPDATE_WHD_STMT_ROW_FAILURE,
    accountId
  };
}

export function updateStatement(accountId, statement, newPaymentTypeOptions) {
  return (dispatch) => {
    dispatch(requestUpdateWhdStatement());
    const promise = () => ApiService
      .updateStatement(accountId, statement)
      .then((response) => {
        if (response.data && response.data.statement && response.data.validationResult) {
          dispatch(receiveUpdateWhdStatement(response.data.statement, response.data.structure, response.data.validationResult, response.data.topAccount));
          toastr.success('Save Successful', 'Statement updated');
        } else {
          toastr.error('Save Failed', 'There was an unexpected response when trying to save the changes');
        }
        if (newPaymentTypeOptions && newPaymentTypeOptions.structureId > 0 && newPaymentTypeOptions.paymentTypes.length > 0) {
          dispatch(updateAvailablePaymentTypes(newPaymentTypeOptions.structureId, newPaymentTypeOptions.paymentTypes));
        }
      })
      .catch(error => dispatch(handleException(error, () => dispatch(rejectUpdateWhdStatement(accountId)), true)));

    return promise();
  };
}

export function updateStatementRow(accountId, rowUpdate) {
  return (dispatch) => {
    dispatch(requestUpdateWhdStatementRow());
    const promise = () => ApiService
      .updateStatementRow(accountId, rowUpdate)
      .then((response) => {
        if (response.data && response.data.statement && response.data.structure) {
          dispatch(receiveUpdateWhdStatementRow(response.data.statement, response.data.structure, response.data.isStructureValid, response.data.validationResult, response.data.topAccount));
          toastr.success('Save Successful', 'Statement updated');
        } else {
          toastr.error('Save Failed', 'There was an unexpected response when trying to save the changes');
        }
      })
      .catch(error => dispatch(handleException(error, () => dispatch(rejectUpdateWhdStatementRow(accountId)), true)));

    return promise();
  };
}
